export class HistogramItemResponseModel {
    public value = 0;
    public cumulativeLessCount = 0;
    public cumulativeMoreCount = 0;
}